export default __webpack_public_path__ + "static/media/task_due_age.0085f1f4.svg";